import { RoomVertex } from '../objects/RoomVertex';

export class VertexList {
	first: RoomVertex | null = null;
	last: RoomVertex | null = null;
	length = 0;
	private isClosed = false;

	add(vertex: RoomVertex) {
		if (!this.first) {
			this.first = vertex;
			this.last = vertex;
		} else {
			if (!this.last) return;

			this.last.next = vertex;
			vertex.prev = this.last;
			this.last = vertex;
		}

		this.length++;

		if (this.isClosed) this.closeLoop();
	}

	remove(vertex: RoomVertex) {
		if (this.isClosed) this.openLoop();

		if (vertex.prev) vertex.prev.next = vertex.next;
		if (vertex.next) vertex.next.prev = vertex.prev;

		if (this.first === vertex) this.first = vertex.next;
		if (this.last === vertex) this.last = vertex.prev;

		vertex.prev = null;
		vertex.next = null;

		this.length--;
	}

	closeLoop() {
		if (!this.first || !this.last || this.length < 3) return;

		this.last.next = this.first;
		this.first.prev = this.last;
		this.isClosed = true;

		this.forEach((v) => {
			v.init();
		});

		this.forEach((v) => {
			v.compute();
		});
	}

	openLoop() {
		if (!this.first || !this.last || !this.isClosed) return;

		this.last.next = null;
		this.first.prev = null;
		this.isClosed = false;
	}

	forEach(callback: (v: RoomVertex) => void) {
		let current = this.first;
		const visited = new Set<RoomVertex>();

		while (current && !visited.has(current)) {
			callback(current);
			visited.add(current);
			current = current.next;
		}
	}

	toArray() {
		const arr: RoomVertex[] = [];
		this.forEach((v) => arr.push(v));

		return arr;
	}

	export() {
		return this.toArray().map((v) => v.export());
	}

	isLoopClosed() {
		return this.isClosed;
	}
}
